"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurableListTable = void 0;
const showFormDialog_1 = require("@juvare/common-form-ui/showFormDialog");
const AppPage_1 = require("@juvare/common-web-ui/AppPage");
const AppPageHeader1_1 = require("@juvare/common-web-ui/AppPageHeader1");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const components_1 = require("../../../../ui/components");
const hooks_1 = require("../../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const Column = (props) => (react_1.default.createElement(material_1.Typography, { sx: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word',
        WebkitLineClamp: 4,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
    } }, props.label));
const formConfig = {
    type: 'form',
    children: [
        {
            label: 'Name',
            validate: {
                required: true,
            },
            key: 'name',
            type: 'form.text',
        },
        {
            label: 'Description',
            validate: {
                required: true,
            },
            key: 'description',
            type: 'form.text',
        },
        {
            type: 'form.dataGrid',
            label: 'Values',
            reorder: false,
            key: 'value',
            children: [
                {
                    label: 'Value',
                    validate: {
                        required: true,
                    },
                    key: 'value',
                    type: 'form.text',
                },
                {
                    label: 'Label',
                    validate: {
                        required: true,
                    },
                    key: 'label',
                    type: 'form.text',
                },
            ],
        },
    ],
};
function ConfigurableListTable(props) {
    var _a, _b;
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const storageClient = (0, hooks_1.useStorageClient)(props.entity);
    const [reloadFlag, setReloadFlag] = react_1.default.useState();
    const appTitle = (_a = props.title) !== null && _a !== void 0 ? _a : 'Configurable List';
    const handleOpenDialog = (row) => {
        let values;
        if (row === null || row === void 0 ? void 0 : row.columns) {
            values = Object.assign(Object.assign({}, row.columns), { value: JSON.parse(row === null || row === void 0 ? void 0 : row.columns.value) });
        }
        (0, showFormDialog_1.showFormDialog)({
            title: appTitle,
            data: values,
            config: formConfig,
            onSubmit: (data) => {
                data.value = JSON.stringify(data.value);
                let postAction = {
                    action: 'create',
                    data: data,
                };
                if (row) {
                    postAction = {
                        action: 'partial-update',
                        id: row.id,
                        data: data,
                    };
                }
                storageClient
                    .post(postAction)
                    .then(() => {
                    navigationContext.clearChanged();
                    (0, SnackbarHelper_1.showInfoSnackbar)({ message: 'Saved', autoHideDuration: 2000 });
                    setReloadFlag({});
                })
                    .catch((error) => {
                    if (isErrorColumnNotUnique(error, 'name')) {
                        error.message = `Configurable list with this name already exists.`;
                    }
                    (0, SnackbarHelper_1.handleErrorSnackbar)(error);
                });
            },
        });
    };
    return (react_1.default.createElement(AppPage_1.AppPage, { header: react_1.default.createElement(AppPageHeader1_1.AppPageHeader1, { title: (_b = props.title) !== null && _b !== void 0 ? _b : 'Configurable List', onCreate: props.canCreate ? () => handleOpenDialog() : undefined }) },
        react_1.default.createElement(components_1.EntityTable, { entity: props.entity, columns: [
                {
                    name: 'name',
                    label: 'Name',
                    sortable: true,
                    render: (row) => react_1.default.createElement(Column, { label: row.columns.name }),
                },
                {
                    name: 'description',
                    label: 'Description',
                    sortable: true,
                    render: (row) => react_1.default.createElement(Column, { label: row.columns.description }),
                },
            ], fullTextSearchField: 'search', reloadFlag: reloadFlag, onSelectRow: handleOpenDialog, rowMenuItems: [
                {
                    label: 'Delete',
                    onClick: (row) => {
                        var _a;
                        if ((_a = props.deleteProtectedLists) === null || _a === void 0 ? void 0 : _a.includes(row.columns.name)) {
                            return (0, DialogHelper_1.showAlertDialog)({
                                title: 'Can not remove',
                                content: (react_1.default.createElement(material_1.Typography, null, "Can not remove this configurable list because it is being used in application.")),
                            });
                        }
                        else {
                            return (0, DialogHelper_1.showConfirmDialog)({
                                title: `Delete list`,
                                content: react_1.default.createElement(material_1.Typography, null, "Are you sure you want to delete this list?"),
                                onConfirm: () => storageClient.post({ action: 'delete', id: row.id }).then(() => setReloadFlag({})),
                            });
                        }
                    },
                },
            ] })));
}
exports.ConfigurableListTable = ConfigurableListTable;
function isErrorColumnNotUnique(error, column) {
    return (error &&
        column &&
        error.data &&
        Array.isArray(error.data.errors) &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error.data.errors.find((err) => {
            return err.column && err.column === column && err.error && err.error === 'not-unique';
        }));
}
